<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de pacientes ativos ConectaSUS - Cidadão">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/cadastro/relatorio-paciente-conecta-cidadao/List'

export default {
    components: { List },
}
</script>
